import { ConfirmDialogIdentifier } from 'legacy/lut/components/shared/Confirm/actions'
import { ConfirmationDialog } from 'legacy/lut/components/shared/Confirm/ConfirmationDialog'
import { FC } from 'react'

import { TRANSLATION_KEYS } from '../../translations'

export const applicableChangeConfirmDialogIdentifier: ConfirmDialogIdentifier =
  'AssortmentApplicableChangeConfirmDialog'

export const ApplicableChangeConfirmDialog: FC = () => {
  return (
    <ConfirmationDialog
      translation
      identifier={applicableChangeConfirmDialogIdentifier}
      // text="Are you sure you want to delete this card?"
      text={TRANSLATION_KEYS.applicableConfirm.message}
      submitText={TRANSLATION_KEYS.applicableConfirm.okButton}
      cancelText={TRANSLATION_KEYS.applicableConfirm.cancelButton}
    />
  )
}
